<template>
    <ion-card class="-light">
        <ion-list>
            <ion-list-header>Beteiligte Personen</ion-list-header>
            <ion-item
                v-for="(value, index) in formData.beteiligte"
                :key="index"
                @click="
                    openBeteiligteDataModal(index, formData.beteiligte[index])
                "
            >
                <span v-if="value.rolle !== ''">{{ value.rolle }}:&ensp;</span
                ><span v-if="value.vorname !== ''"
                    >{{ value.vorname }}&ensp;</span
                >{{ value.zuname }}
                <span
                    v-if="
                        value.rolle === '' &&
                        value.vorname === '' &&
                        value.zuname === ''
                    "
                    >Person {{ index + 1 }}</span
                >
                <ion-button
                    slot="end"
                    @click.stop="deletePerson(index)"
                    fill="clear"
                >
                    <ion-icon name="trash" slot="icon-only"></ion-icon>
                </ion-button>
            </ion-item>
        </ion-list>
        <ion-button
            expand="block"
            class="ion-margin-top ion-margin-bottom"
            @click="openBeteiligteDataModal(formData.beteiligte.length)"
            fill="outline"
            >Person hinzufügen</ion-button
        >
    </ion-card>
</template>

<script>
import BeteiligteDataModal from "@/components/BeteiligteDataModal";

export default {
    components: {},
    props: {
        formData: {
            required: true,
            type: Object,
        },
    },
    methods: {
        openBeteiligteDataModal(key, data) {
            if (data !== undefined) {
                data = Object.assign({}, data);
            }
            this.$ionic.modalController
                .create({
                    component: BeteiligteDataModal,
                    componentProps: {
                        propsData: {
                            beteiligteId: key,
                            beteiligteData: data,
                            isRechtschutz: this.formData.mode === "recht",
                        },
                        parent: this,
                    },
                    backdropDismiss: false,
                })
                .then((a) => {
                    a.onDidDismiss().then((beteiligteData) => {
                        if (
                            "data" in beteiligteData &&
                            beteiligteData.data !== undefined &&
                            "beteiligteFormData" in beteiligteData.data
                        ) {
                            this.personAdded(
                                beteiligteData.data.beteiligteFormData
                            );
                        }
                    });
                    a.present();
                });
        },
        personAdded(beteiligteFormData) {
            if (
                this.formData.beteiligte.length >
                beteiligteFormData.beteiligteId
            ) {
                this.$set(
                    this.formData.beteiligte,
                    beteiligteFormData.beteiligteId,
                    beteiligteFormData
                );
            } else {
                this.$emit("person-added", beteiligteFormData);
            }
        },
        deletePerson(index) {
            this.$ionic.alertController
                .create({
                    header: "Person löschen",
                    message:
                        "Möchtest du die beteiligte Person wirklich löschen?",
                    buttons: [
                        {
                            text: "Nein",
                            role: "cancel",
                        },
                        {
                            text: "Ja",
                            handler: () => {
                                this.$emit("delete-person", index);
                            },
                        },
                    ],
                })
                .then((a) => a.present());
        },
    },
};
</script>

<style></style>
